const getItem = (key: any) => localStorage.getItem(key);

const setItem = (key: any, value: any) => {
  if (key && value) localStorage.setItem(key, value);
};

const removeItem = (key: any) =>
  localStorage.removeItem(key);

const clearAllLS = () => {
  localStorage.clear();
};

// App
const sidebarStatusKey = 'sidebar_status';
export const getSidebarStatus = () =>
  getItem(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) =>
  setItem(sidebarStatusKey, sidebarStatus);

const languageKey = 'language';
export const getLanguage = () => getItem(languageKey);
export const setLanguage = (language: string) =>
  setItem(languageKey, language);

const sizeKey = 'size';
export const getSize = () => getItem(sizeKey);
export const setSize = (size: string) =>
  setItem(sizeKey, size);

// User
const tokenKey = 'ework_admin_access_token';
const tokenData = 'tokenData';
export const getToken = () => getItem(tokenKey);
export const getTokenData: any | null = () => getItem(tokenData);
// export const getTokenData = () => {
//   const result = getItem(tokenData)
//   console.log('typeof result: ', typeof result);
//   return result ? JSON.parse(result) : ""
// };
export const setToken = (token: string) =>
  setItem(tokenKey, token);
export const setTokenData = (token: any) =>
  setItem(tokenData, token);
export const removeToken = () => removeItem(tokenKey);

export { getItem, setItem, removeItem, clearAllLS };